import { Checkbox, CheckboxProps } from "@mui/material";
import classes from "./checkbox.module.scss";
import { FC } from "react";

export const CustomCheckbox: FC<CheckboxProps> = (props) => {
  return (
    <Checkbox
      {...props}
      classes={{
        root: classes.checkbox,
        checked: classes.checkboxChecked,
        disabled: classes.checkboxDisabled,
      }}
      className={`${classes.checkboxHover} ${props.className}`}
    />
  );
};
